module.exports = __webpack_public_path__ + "img/Brand.07987ab4.svg";